import { jsx, jsxs } from 'react/jsx-runtime';
import { ClipboardCheck } from '../../../icons/ClipboardCheck.js';
import { ReceiptIcon } from '../../../icons/ReceiptIcon.js';
import { WrenchIcon } from '../../../icons/WrenchIcon.js';
import { ShieldIcon } from '../../../icons/ShieldIcon.js';

const DEFAULT_ICONS = [
    jsx(WrenchIcon, {}, "wrench"),
    jsx(ShieldIcon, {}, "shield"),
    jsx(ClipboardCheck, {}, "clipboard"),
    jsx(ReceiptIcon, {}, "receipt"),
];
const DEFAULT_BENEFITS = [
    {
        title: 'For your convenience',
        subcopy: 'Gain quick and easy access to product manuals, replacement parts, tips and more.',
    },
    {
        title: 'For your safety',
        subcopy: 'You are certain to be contacted in the unlikely event a safety notification is required.',
    },
    {
        title: 'Warranty service',
        subcopy: 'Obtain a more efficient warranty service in case there is a problem with your product (with a valid model number).',
    },
    {
        title: 'Confirmation of ownership',
        subcopy: 'Always have proof of purchase in case of an insurance loss (ex. fire, flood or theft).',
    },
];
// Static map ensures full class strings are visible to Tailwind's scanner at build time.
// Avoid constructing class names dynamically (e.g. `sm:grid-cols-${n}`) as they get purged.
const GRID_COLS_MAP = {
    1: 'sm:grid-cols-1',
    2: 'sm:grid-cols-2',
    3: 'sm:grid-cols-3',
    4: 'sm:grid-cols-4',
    5: 'sm:grid-cols-5',
    6: 'sm:grid-cols-6',
};
const styles = {
    wrapper: 'w-full bg-(--color-bg-main-container) py-space-500 px-space-400',
    heading: 'text-center text-h2 text-(--color-text-headline) mb-space-500',
    gridBase: 'max-w-7xl mx-auto grid grid-cols-2 gap-space-400',
    item: 'flex flex-col items-center text-center gap-space-200',
    icon: 'w-10 h-10 flex items-center justify-center text-(--brand-primary)',
    title: 'text-body-strong text-(--color-text-body)',
    subcopy: 'text-body text-(--color-text-body)',
};
const RegBenefits = ({ heading, icons }) => {
    const count = icons?.length ?? DEFAULT_BENEFITS.length;
    const gridCols = `${styles.gridBase} ${GRID_COLS_MAP[count] ?? GRID_COLS_MAP[4]}`;
    return (jsxs("div", { className: styles.wrapper, children: [heading && jsx("h2", { className: styles.heading, children: heading }), jsx("ul", { className: gridCols, children: DEFAULT_BENEFITS.map((benefit, index) => {
                    const icon = icons?.[index] ?? DEFAULT_ICONS[index] ?? DEFAULT_ICONS[0];
                    return (jsxs("li", { className: styles.item, children: [jsx("span", { className: styles.icon, "aria-hidden": "true", children: icon }), jsx("p", { className: styles.title, children: benefit.title }), jsx("p", { className: styles.subcopy, children: benefit.subcopy })] }, `${index}-${benefit.title}`));
                }) })] }));
};

export { RegBenefits };
